import { useTranslation } from 'react-i18next';
import { STATUS_COLORS, type OrderStatus } from '@/lib/orders-client';

// Maps backend order-status enum values → their 'orders' locale key (status.*).
// Never send these keys to the API; they are for rendering only.
export const ORDER_STATUS_KEYS: Record<OrderStatus, string> = {
    draft: 'draft',
    pending: 'pending',
    confirmed: 'confirmed',
    completed: 'completed',
    pending_payment: 'pendingPayment',
    pos_push_failed: 'posPushFailed',
    pushed_to_external_pending: 'pushedToExternalPending',
    pushed_to_external: 'pushedToExternal',
    cancelled: 'cancelled',
    abandoned: 'abandoned',
    superseded: 'superseded',
};

interface OrderStatusBadgeProps {
    status: OrderStatus;
    /** `sm` is the board card's pill; `md` suits lists and panel headers. */
    size?: 'sm' | 'md';
}

export function OrderStatusBadge({ status, size = 'md' }: OrderStatusBadgeProps) {
    const { t } = useTranslation('orders');
    const colorClass = STATUS_COLORS[status];
    const metrics = size === 'sm' ? 'gap-1 px-1.5 py-0.5 text-[10px]' : 'gap-1.5 px-2.5 py-0.5 text-xs';

    return (
        <span
            className={`inline-flex items-center whitespace-nowrap rounded-full font-medium ${metrics} ${colorClass}`}
        >
            {/* The dot takes the pill's text colour, so the status reads by colour even in a dense row. */}
            <span aria-hidden="true" className="size-1.5 shrink-0 rounded-full bg-current opacity-70" />
            {t(`status.${ORDER_STATUS_KEYS[status]}`)}
        </span>
    );
}
